import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import SettingsIcon from "@mui/icons-material/Settings";
import { useState } from "react";
import SetLockupPeriodModal from "../modals/SetLockupPeriodModal";
import { Ownership } from "../../../../../apis/__generated__/graphql";

export interface SetLockupPeriodProps {
  refetch: () => void;
  row?: Ownership;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function SetLockupPeriodButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: SetLockupPeriodProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="Setting"
        icon={
          <Tooltip title="Submit setting deadline proposal">
            <SettingsIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && (
        <SetLockupPeriodModal
          row={row}
          open={open}
          onClose={handleClose}
          refetch={refetch}
        />
      )}
    </>
  );
}
